module.exports = __webpack_public_path__ + "static/img/topbg.de5e9ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topbg.png
// module id = DW8A
// module chunks = 1